import { useEffect, useRef, useState } from "react";
import Layout from "../../Layout";
import profile from "../../assets/images/profile.png";
import age from "../../assets/newicons/genter.svg";
import genter from "../../assets/newicons/male.svg";
import patient from "../../assets/newicons/badge.svg";
import blood from "../../assets/newicons/blood.svg";
import height from "../../assets/newicons/height.svg";
import weight from "../../assets/newicons/monitor_weight.svg";
import contact from "../../assets/newicons/call.svg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import UpcomingAppointments from "./UpcomingAppointments";
import MedicalRecords from "./MedicalRecords";
import MedicalHistory from "./MedicalHistory";
import { calculateAge } from "../../utils/convertionFunc";
import VitalService from "../../Services/VitalService";
import AppointmentService from "../../Services/AppointmentService";
import ChronicConditionService from "../../Services/ChronicConditionService";
import MedicalService from "../../Services/MedicalService";
import LabService from "../../Services/LabService";
import AuthService from "../../Services/AuthService";
import AddVitals from "../MedicalRecords/MyVitals/AddVitals";
import { Avatar, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import PatientService from "../../Services/PatientService";
import dayjs from "dayjs";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import Calendar from "./Calendar";
import CarePlanMed from "./CarePlanMed";
import CarePlanActivity from "./CarePlanActivity";
import { FaCalendarAlt } from "react-icons/fa";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import medicineB from "../../assets/careplanicons/medicineB.svg";
import medicineW from "../../assets/careplanicons/medicineW.svg";
import taskB from "../../assets/careplanicons/taskB.svg";
import taskW from "../../assets/careplanicons/taskW.svg";
import vitalsB from "../../assets/careplanicons/vitalsB.svg";
import vitalsW from "../../assets/careplanicons/vitalsW.svg";
import CarePlanService from "../../Services/CarePlanService";
import AllAndRPMVitals from "./AllAndRPMVitals";
import { HiOutlinePlusSm } from "react-icons/hi";
import Garmin from "./Garmin";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import CalendarView from "./CalendarView";

const data = [
  { name: "Day 1", Calories: 400, Carbohydrate: 600 },
  { name: "Day 2", Calories: 300, Carbohydrate: 700 },
  { name: "Day 3", Calories: 350, Carbohydrate: 650 },
  { name: "Day 4", Calories: 370, Carbohydrate: 670 },
  { name: "Day 5", Calories: 360, Carbohydrate: 690 },
  { name: "Day 6", Calories: 390, Carbohydrate: 660 },
  { name: "Day 7", Calories: 410, Carbohydrate: 720 },
];

function DashboardNew() {
  const navigate = useNavigate();
  const [vitalsData, setVitalsData] = useState([]);
  const [loading, setLoading] = useState({
    vitals: false,
    lab: false,
    appointment: false,
    presc: false,
  });

  const activePatient = JSON.parse(localStorage.getItem("patientData"));
  const patientCode = activePatient?.patientId;
  const [patientData, setPatientData] = useState([]);
  const [profileImage, setProfileImage] = useState();
  const [appointmentData, setAppoinmentData] = useState([]);
  const [labData, setLabData] = useState([]);
  const [prescriptionsList, setPrescriptionsList] = useState([]);
  const patJson = localStorage.getItem("patientData");
  const patObj = patJson ? JSON.parse(patJson) : null;
  const [selectedPatient, setSelectedPatient] = useState(patObj);
  const [VitalOpen, setVitalOpen] = useState(false);
  const [careOption, setCareOption] = useState("vital");
  const [medicalHistory, setMedicalHistory] = useState({
    chronicConditions: [],
    pastHistoryData: [],
    patientAllergyData: [],
    surgicalHistoryData: [],
    familyData: [],
    socialHistoryData: [],
    medicationData: [],
    immunisations: [],
    emc: [],
  });
  const [showVitals, setShowVitals] = useState("");
  const [rpmVitals, setRpmVitals] = useState({});

  useEffect(() => {
    MyVitalList();
    PatientchronicConditions();
    PastHistory();
    PatientAllergies();
    SurgicalHistory();
    FamilyHistory();
    SocialHistory();
    Medication();
    fetchAllPrescriptions();
    labReport();
    PatientDetail();
    Immunisations();
    rpmData();
  }, []);

  const PatientDetail = async () => {
    try {
      const payload = { patientId: patientCode };
      const result = await PatientService.getPatient(payload);

      if (result.data) {
        const fetchedData = result.data || [];
        setPatientData(fetchedData);
        const photoName = fetchedData[0]?.photoName;
        setProfileImage(
          photoName ? process.env.REACT_APP_IMAGE_URL + photoName : null
        );

        if (
          fetchedData[0] &&
          (fetchedData[0]?.dob || fetchedData[0]?.patientId)
        ) {
          if (fetchedData[0]?.dob) {
            let inputDob = fetchedData[0]?.dob;
            if (typeof inputDob === "number") {
              const dobString = inputDob.toString();
              const year = dobString.slice(0, 4);
              const month = dobString.slice(4, 6);
              const day = dobString.slice(6, 8);
              inputDob = `${month}/${day}/${year}`;
            }
            const formattedDob = dayjs(inputDob, "MM/DD/YYYY");
            if (formattedDob.isValid()) {
              const updatedPatientData = [...fetchedData];
              updatedPatientData[0].dob = formattedDob.format("MM/DD/YYYY");
              updatedPatientData[0].dob = formattedDob;
              setPatientData(updatedPatientData);
              const photoName = updatedPatientData[0]?.photoName;
              setProfileImage(
                photoName ? process.env.REACT_APP_IMAGE_URL + photoName : null
              );
              // form.setFieldsValue(updatedPatientData[0]);
            } else {
              console.error("Invalid date format:", fetchedData[0]?.dob);
            }
          } else {
            // form.setFieldsValue(fetchedData[0]);
          }
        } else {
          console.error("No patient data or invalid patient ID");
        }
      }
    } catch (error) {
      console.error("Error fetching patient details:", error);
      // form.resetFields();
    }
  };

  const MyVitalList = async () => {
    try {
      setLoading({
        ...loading,
        vitals: true,
      });
      const result = await VitalService.getVitalsRecentData(patObj?.patientId);

      // const result = await VitalService.getVitalsData({
      //   patientId: patObj?.patientId,
      // });
      console.log("Doxzonclinic", result);
      setVitalsData(result.data);
      // props.onClose(result.data)
      setLoading({
        ...loading,
        vitals: false,
      });
    } catch (error) {
      console.error(error);
      setLoading({
        ...loading,
        vitals: false,
      });
    } finally {
      setLoading({
        ...loading,
        vitals: false,
      });
    }
  };

  const rpmData = async () => {
    if (patObj?.rpmApplicable === "Y") {
      let payload = {
        patientId: patObj?.patientId,
        // satus: 1,
      };
      try {
        const result = await CarePlanService.PatientRPMVitalsConfig(payload);
        setRpmVitals(result?.data.data[0]);
        setShowVitals("RPM");
      } catch (error) {}
    } else {
      setShowVitals("ALL");
    }
  };

  const handleViewVital = () => {
    navigate("/myvitals");
  };
  const showModal2 = () => {
    setVitalOpen(true);
  };

  const handleCancel = (code) => {
    // setIsModalOpen(false);
    // setTrendOpen(false)
    setVitalOpen(false);
    MyVitalList();
  };

  const PatientchronicConditions = () => {
    let payload = {
      patientId: patObj?.patientId,
    };
    ChronicConditionService.PatientchronicConditions(payload)
      .then((res) => {
        setMedicalHistory((prev) => ({
          ...prev,
          chronicConditions: res.data,
        }));
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const PastHistory = () => {
    let payload = {
      patientId: patObj?.patientId,
      status: 1,
    };
    MedicalService.PastMedicalHistory(payload)
      .then((res) => {
        setMedicalHistory((prev) => ({
          ...prev,
          pastHistoryData: res.data,
        }));
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const PatientAllergies = () => {
    let payload = {
      patientCode: patObj?.patientId,
      status: 1,
    };
    MedicalService.PatientAllergiesList(payload)
      .then((res) => {
        setMedicalHistory((prev) => ({
          ...prev,
          patientAllergyData: res.data,
        }));
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const SurgicalHistory = () => {
    let payload = {
      patientId: patObj?.patientId,
      status: 1,
    };
    MedicalService.PatientSurgicalHistory(payload)
      .then((res) => {
        setMedicalHistory((prev) => ({
          ...prev,
          surgicalHistoryData: res.data,
        }));
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const FamilyHistory = () => {
    let payload = {
      patientId: patObj?.patientId,
    };
    MedicalService.PatientFamilyHistory(payload)
      .then((res) => {
        setMedicalHistory((prev) => ({
          ...prev,
          familyData: res.data,
        }));
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const SocialHistory = () => {
    let payload = {
      patientId: patObj?.patientId,
      status: 1,
    };
    MedicalService.PatientSocialHistory(payload)
      .then((res) => {
        setMedicalHistory((prev) => ({
          ...prev,
          socialHistoryData: res.data,
        }));
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const Medication = () => {
    let payload = {
      patientCode: patObj?.patientId,
      status: 1,
    };
    MedicalService.PatientMedication(payload)
      .then((res) => {
        setMedicalHistory((prev) => ({
          ...prev,
          medicationData: res.data,
        }));
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const Immunisations = () => {
    let payload = {
      patientId: patObj?.patientId,
      status: 1,
    };
    MedicalService.PatientImmunisation(payload)
      .then((res) => {
        setMedicalHistory((prev) => ({
          ...prev,
          immunisations: res.data,
        }));
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const labReport = () => {
    setLoading({
      ...loading,
      lab: true,
    });
    let payload = {
      status: 1,
      patientId: patObj?.patientId,
    };
    if (!patientData?.parentPatientId) {
      payload.includeFamilyMember = "Y";
    }
    LabService.getLabReportData(payload)
      .then((result) => {
        setLoading({
          ...loading,
          lab: false,
        });
        if (result.data.length > 4) {
          setLabData(result.data.splice(0, 4));
        } else {
          setLabData(result.data);
        }
      })
      .catch((error) => {
        console.error(error);
        setLoading({
          ...loading,
          lab: false,
        });
      });
  };

  const fetchAllPrescriptions = async () => {
    setLoading({
      ...loading,
      presc: true,
    });
    try {
      let payload = {
        patientId: patObj?.patientId,
        detailsYN: "Y",
        status: 2,
      };
      if (!patientData?.parentPatientId) {
        payload.includeFamilyMember = "Y";
      }

      const response = await AuthService.getMyPrescriptionView(payload);
      setLoading({
        ...loading,
        presc: false,
      });
      if (response.data.length > 4) {
        setPrescriptionsList(response.data.splice(0, 4));
      } else {
        setPrescriptionsList(response.data);
      }
    } catch (error) {
      console.error(error);
      setLoading({
        ...loading,
        presc: false,
      });
    }
  };

  const handleCareOption = (option) => {
    setCareOption(option);
  };

  const [startDate, setStartDate] = useState(dayjs());
  const [weekDays, setWeekDays] = useState([]);
  const [selectedDate, setSelectedDate] = useState(dayjs());

  useEffect(() => {
    generateWeekDays(startDate);
  }, [startDate]);

  const generateWeekDays = (centerDate) => {
    const tempDays = [];
    const start = centerDate.clone().subtract(3, "day");
    for (let i = 0; i < 7; i++) {
      const date = start.clone().add(i, "day");
      tempDays.push({
        day: date.format("ddd"),
        dateNum: date.format("D"),
        fullDate: date.format("YYYY-MM-DD"),
        dateObj: date,
      });
    }
    setWeekDays(tempDays);
  };

  const handleSelectDate = (dateObj) => {
    setSelectedDate(dateObj);
    setStartDate(dateObj);
  };

  const monthYear = selectedDate.format("MMMM YYYY");
  const handleResetToToday = () => {
    const today = dayjs();
    setSelectedDate(today);
    setStartDate(today);
  };

  const slickRef = useRef(null);
  const [garminIndex, setGarminIndex] = useState(0);

  const visibleCards = 5;
  const totalGarminCards = 6;
  const maxGarminIndex = totalGarminCards - visibleCards;

  const handleNext = () => {
    if (slickRef.current) slickRef.current.slickNext();

    setGarminIndex((prev) => Math.min(prev + 1, maxGarminIndex));
  };

  const handlePrev = () => {
    if (slickRef.current) slickRef.current.slickPrev();
    setGarminIndex((prev) => Math.max(prev - 1, 0));
  };

  const handlePrevDate = () => {
    setStartDate((prev) => {
      const newDate = prev.subtract(1, "day");
      setSelectedDate(newDate);
      return newDate;
    });
  };

  const handleNextDate = () => {
    setStartDate((prev) => {
      const newDate = prev.add(1, "day");
      setSelectedDate(newDate);
      return newDate;
    });
  };
  const rpmKeys = [
    "temperature",
    "systolic",
    "diastolic",
    "respiratoryRate",
    "spo2",
    "heartRate",
    "height",
    "weight",
    "bmi",
  ];
  const allVitalsConfigured = rpmKeys.every((key) => rpmVitals?.[key] === 1);

  return (
    <Layout>
      <div className="bg-green-50 p-4 ">
        <div className="xl:flex lg:flex rounded-lg gap-4 mt-1">
          <div className="bg-white p-5 border-2 border-[#D4D4D4] rounded-xl shadow-lg w-full md:w-[35%] lg:w-[30%] xl:w-[20%]">
            <div className="flex flex-col items-center">
              <Avatar
                size={48}
                src={profileImage}
                className="rounded-full w-12 h-12 border object-cover bg-[#189FAA] text-white text-xl font-semibold flex items-center justify-center"
              >
                {!profileImage && patObj?.firstName?.charAt(0).toUpperCase()}
              </Avatar>
              <h2 className="mt-3 font-sans font-semibold text-xs text-[#333333]">
                {patObj?.firstName} {patObj?.lastName}
              </h2>
              <div className="flex gap-2 w-full justify-center mt-3">
                <div className="flex gap-2 items-center">
                  <img src={age} alt="" className="w-3 h-4" />
                  <h2 className="font-sans font-normal text-xs text-[#333333]">
                    {calculateAge(patObj?.ageDob)}Years
                  </h2>
                </div>
                <div className="border-l-2"></div>
                <div className="flex gap-2 items-center">
                  <img src={genter} alt="" className="w-4 h-5" />
                  <h2 className="font-sans font-normal text-xs text-[#333333]">
                    {patObj?.gender === "M"
                      ? "Male"
                      : patObj?.gender === "F"
                      ? "Female"
                      : ""}
                  </h2>
                </div>
              </div>
            </div>
            <hr className="mt-3" />
            <div className="flex justify-center">
              <div className="mt-5 gap-4 flex flex-col justify-center">
                <div className="flex items-center gap-2">
                  <div className="flex gap-2 items-center w-32">
                    <img src={patient} alt="" className="w-5 h-5" />
                    <h2 className="font-sans font-normal text-xs text-[#828282]">
                      Patient ID:
                    </h2>
                  </div>
                  <p className="text-[#333333] font-sans font-medium text-xs">
                    {patObj?.patientId}
                  </p>
                </div>
                <hr className="" />
                <div className="flex items-center gap-2">
                  <div className="flex gap-2 items-center w-32">
                    <img src={blood} alt="" className="w-5 h-5" />
                    <h2 className="font-sans font-normal text-xs text-[#828282]">
                      Blood Group:
                    </h2>
                  </div>
                  <p className="text-[#333333] font-sans font-medium text-xs">
                    {patObj?.bloodGroup}
                  </p>
                </div>
                <hr className="" />

                <div className="flex items-center gap-2">
                  <div className="flex gap-2 items-center w-32">
                    <img src={height} alt="" className="w-5 h-5" />
                    <h2 className="font-sans font-normal text-xs text-[#828282]">
                      Height:
                    </h2>
                  </div>
                  <p className="text-[#333333] font-sans font-medium text-xs">
                    {vitalsData.find((vit) => vit.vitalCode === "HI")?.value} cm
                  </p>
                </div>
                <hr className="" />

                <div className="flex items-center gap-2">
                  <div className="flex gap-2 items-center w-32">
                    <img src={weight} alt="" className="w-5 h-5" />
                    <h2 className="font-sans font-normal text-xs text-[#828282]">
                      Weight:
                    </h2>
                  </div>
                  <p className="text-[#333333] font-sans font-medium text-xs">
                    {vitalsData.find((vit) => vit.vitalCode === "WE")?.value} Kg
                  </p>
                </div>
                <hr className="" />

                <div className="flex items-center gap-2">
                  <div className="flex gap-2 items-center w-32">
                    <img src={contact} alt="" className="w-5 h-5" />
                    <h2 className="font-sans font-normal text-xs text-[#828282]">
                      Contact:
                    </h2>
                  </div>
                  <p className="text-[#333333] font-sans font-medium text-xs">
                    {patObj?.mobile}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-[#F4FEFF] rounded-xl w-full border-[#99DEE4] border-2 overflow-x-scroll scrollBarWidth shadow-lg flex-1 xl:mt-0 lg:mt-4 mt-4">
            <div className="flex justify-between items-center p-2 mx-2 mt-2">
              <div className="flex items-center gap-3">
                <span className="text-[#D8383A] font-sans text-base font-semibold">
                  {patObj?.rpmApplicable === "Y" && " Care Plan "}
                </span>
                <div className="flex justify-between items-center px-4">
                  <div className="flex items-center gap-5">
                    <div className="xl:flex lg:flex lg:gap-1 gap-3 grid grid-col-1 border rounded-full">
                      <div className="flex gap-1">
                        <span
                          onClick={() => handleCareOption("vital")}
                          className={`rounded-full w-24 flex gap-2 text-sm font-sans cursor-pointer text-center justify-center items-center px-2  ${
                            careOption === "vital" && "bg-[#189FAA] text-white"
                          }`}
                        >
                          <img
                            src={careOption === "vital" ? vitalsW : vitalsB}
                            alt="vitals"
                            className="w-4 h-4"
                          />
                          <span>Vitals</span>
                        </span>
                      </div>

                      {patObj?.rpmApplicable == "Y" && (
                        <div className="flex gap-1 items-center">
                          <span
                            onClick={() => handleCareOption("med")}
                            className={`rounded-full w-32 cursor-pointer text-center text-sm font-sans items-center flex gap-2 justify-center px-2 py-1 ${
                              careOption === "med" && "bg-[#189FAA] text-white"
                            }`}
                          >
                            <img
                              src={careOption === "med" ? medicineW : medicineB}
                              alt="med"
                              className="w-4 h-4"
                            />
                            <sapn>Medications</sapn>
                          </span>
                        </div>
                      )}
                      {patObj?.rpmApplicable == "Y" && (
                        <span
                          onClick={() => handleCareOption("task")}
                          className={`rounded-full w-24 justify-center cursor-pointer text-sm font-sans text-center flex gap-2 items-center px-2 ${
                            careOption === "task" && "bg-[#189FAA] text-white"
                          }`}
                        >
                          <img
                            src={careOption === "task" ? taskW : taskB}
                            alt="vitals"
                            className="w-4 h-4"
                          />
                          <span>Task</span>
                        </span>
                      )}
                    </div>
                    <div className="h-6 border-l-2 border-gray-300"></div>

                    {careOption == "vital" &&
                      patObj?.rpmApplicable === "Y" &&
                      !allVitalsConfigured && (
                      <div className="flex gap-3 items-center">
                        <span
                          onClick={() => setShowVitals("RPM")}
                          className={` ${
                            showVitals == "RPM"
                              ? "border-primaryColor bg-[#E8FDFF]"
                              : ""
                          }  text-sm font-sans font-medium rounded-full border cursor-pointer py-1 px-4`}
                        >
                          RPM
                        </span>
                        <span
                          onClick={() => setShowVitals("ALL")}
                          className={` ${
                            showVitals == "ALL"
                              ? "border-primaryColor bg-[#E8FDFF]"
                              : ""
                          } text-sm font-sans font-medium rounded-full border cursor-pointer py-1 px-4`}
                        >
                          Show All
                        </span>
                      </div>
                    )}
                    {patObj?.rpmApplicable === "Y" && (
                      <span>
                        <CalendarView />
                      </span>
                    )}
                  </div>
                </div>
              </div>
              {careOption == "vital" ? (
                <div className="flex sm:flex-col  gap-3 items-cente">
                  <button
                    onClick={showModal2}
                    className="border-primaryColor border flex gap-1 items-center font-sans text-sm sm:text-xs font-semibold px-3 py-1 rounded-full"
                  >
                    <HiOutlinePlusSm />
                    Add
                  </button>
                  <p
                    onClick={handleViewVital}
                    className="underline font-sans text-sm cursor-pointer text-[#3082CE] font-semibold"
                  >
                    View all
                  </p>
                </div>
              ) : (
                <div className="rounded-lg w-full max-w-xl flex justify-end items-center gap-2 border-[#F7FEFF] border">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-xs font-sans font-bold text-gray-800">
                      {monthYear}
                    </span>
                  </div>

                  <div className="flex items-center justify-between bg-[#f5fbfd] border px-4 py-2  rounded-md shadow-sm">
                    {/* Left Arrow */}
                    <button
                      onClick={handlePrevDate}
                      className="text-gray-500 hover:text-black"
                    >
                      <FiChevronLeft size={20} />
                    </button>

                    {/* Days */}
                    <div className="flex gap-4 flex-1 justify-center">
                      {weekDays.map((d, index) => {
                        const isSelected =
                          d.fullDate === selectedDate.format("YYYY-MM-DD");

                        return (
                          <button
                            key={index}
                            onClick={() => handleSelectDate(d.dateObj)}
                            className="flex flex-col items-center text-xs focus:outline-none"
                          >
                            <span
                              className={`${
                                isSelected
                                  ? "text-[#00a0c8] font-semibold text-xs font-sans"
                                  : "text-gray-600"
                              }`}
                            >
                              {d.day}
                            </span>
                            <span
                              className={`font-medium text-xs font-sans ${
                                isSelected
                                  ? "text-[#00a0c8] font-semibold"
                                  : "text-gray-800"
                              }`}
                            >
                              {d.dateNum}
                            </span>
                          </button>
                        );
                      })}
                    </div>

                    <div className="flex items-center gap-2">
                      <button
                        onClick={handleNextDate}
                        className="text-gray-500 hover:text-black"
                      >
                        <FiChevronRight size={20} />
                      </button>
                      <FaCalendarAlt
                        className="text-[#00a0c8]"
                        size={16}
                        role="button"
                        onClick={handleResetToToday}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>

            {careOption == "vital" && (
              <div className="mt-3 px-5 relative">
                <AllAndRPMVitals
                  ref={slickRef}
                  vitalsData={vitalsData}
                  setRpmVitals={setRpmVitals}
                  rpmVitals={rpmVitals}
                  setShowVitals={setShowVitals}
                  showVitals={showVitals}
                  index={garminIndex}
                  patientData={patientData}
                />

                <button
                  onClick={handlePrev}
                  className="absolute left-0 top-[32%] -translate-y-1/2 bg-white shadow p-2 rounded-full z-20"
                >
                  <MdChevronLeft size={24} />
                </button>

                {/* Right Arrow */}
                <button
                  onClick={handleNext}
                  className="absolute right-0 top-[32%] -translate-y-1/2 bg-white shadow p-2 rounded-full z-20"
                >
                  <MdChevronRight size={24} />
                </button>
              </div>
            )}
            {careOption == "med" && <CarePlanMed selectedDate={selectedDate} />}
            {careOption == "task" && (
              <CarePlanActivity selectedDate={selectedDate} />
            )}
            {patientData && (
              <>
                <hr className="mx-4 mt-3" />
                <div className="mb-2">
                  <Garmin index={garminIndex} />
                </div>
              </>
            )}
          </div>
        </div>
        <div className="grid grid-cols-3 sm:grid-cols-1 lg:grid-cols-2 gap-5 mt-5">
          <UpcomingAppointments
            appointmentData={appointmentData}
            profileImage={profileImage}
            profile={profile}
          />
          <MedicalRecords
            prescriptionsList={prescriptionsList}
            labData={labData}
            profileImage={profileImage}
          />
          <MedicalHistory {...medicalHistory} />
        </div>
        <div className="mt-5 flex sm:flex-col  justify-between gap-5">
          <Calendar />

          <div className="bg-white rounded-xl shadow-lg p-6 w-full h-[30%] overflow-y-scroll scrollWidth">
            <div className="flex sm:flex-col justify-between items-center mb-4">
              <h2 className="text-base font-sans font-semibold text-[#D8383A]">
                Statistics
              </h2>
              <select className="text-sm font-sans font-semibold border border-gray-300 outline-none cursor-pointer rounded px-2 py-1 text-[#189FAA]">
                <option>Jan 2024 - 5 Day Interval</option>
              </select>
            </div>

            <ResponsiveContainer width="100%" height={245}>
              <LineChart
                data={data}
                className="text-sm font-sans font-semibold"
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line
                  type="monotone"
                  dataKey="Calories"
                  stroke="#00a1e4"
                  activeDot={{ r: 6 }}
                />
                <Line
                  type="monotone"
                  dataKey="Carbohydrate"
                  stroke="#00d2b0"
                  activeDot={{ r: 6 }}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      {VitalOpen && (
        <Modal
          title="Add Vitals"
          visible={VitalOpen}
          onOk={() => {
            setVitalOpen(false);
          }}
          centered={true}
          footer={null}
          onCancel={() => {
            setVitalOpen(false);
          }}
          okText="Submit"
          cancelText="Cancel"
          width={650}
          maskClosable={false}
        >
          <AddVitals
            onClose={() => handleCancel()}
            selectedPatient={selectedPatient}
          />
        </Modal>
      )}
    </Layout>
  );
}

export default DashboardNew;
